import { DateTime } from 'luxon';
import { endOfSaturdayWeek, startOfSundayWeek } from 'components/CalendarWeekView/helpers/getWeekDays';
import { getFormatter } from 'data/services/date/formatter';

export default ({
    date,
    viewType = 'day',
    locale = 'en-US',
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}: {
    date: Date;
    viewType?: 'day' | 'week' | 'month' | 'list';
    locale?: string;
    timezone?: string;
}) => {
    const dateStr = date.toISOString();
    const dateInTz = DateTime
        .fromISO(dateStr)
        .setZone(timezone)
        .setLocale(locale);

    if (['day', 'list'].includes(viewType)) {
        return getFormatter(locale, {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            timeZone: timezone,
        }).format(dateInTz.toJSDate());
    }

    if (viewType === 'week') {
        const from = startOfSundayWeek(dateInTz);
        const to = endOfSaturdayWeek(dateInTz);
        const dateFrom = from.toJSDate();
        const dateTo = to.toJSDate();

        if (from.hasSame(to, 'month')) {
            return [
                getFormatter(locale, { month: 'short', timeZone: timezone }).format(dateFrom),
                getFormatter(locale, { day: 'numeric', timeZone: timezone }).format(dateFrom),
                '-',
                `${getFormatter(locale, { day: 'numeric', timeZone: timezone }).format(dateTo)},`,
                getFormatter(locale, { year: 'numeric', timeZone: timezone }).format(dateTo),
            ].join(' ');
        }

        if (from.hasSame(to, 'year')) {
            return [
                getFormatter(locale, { month: 'short', timeZone: timezone }).format(dateFrom),
                getFormatter(locale, { day: 'numeric', timeZone: timezone }).format(dateFrom),
                '-',
                getFormatter(locale, { month: 'short', timeZone: timezone }).format(dateTo),
                `${getFormatter(locale, { day: 'numeric', timeZone: timezone }).format(dateTo)},`,
                getFormatter(locale, { year: 'numeric', timeZone: timezone }).format(dateTo),
            ].join(' ');
        }

        return [
            getFormatter(locale, { month: 'short', timeZone: timezone }).format(dateFrom),
            `${getFormatter(locale, { day: 'numeric', timeZone: timezone }).format(dateFrom)},`,
            getFormatter(locale, { year: 'numeric', timeZone: timezone }).format(dateFrom),
            '-',
            getFormatter(locale, { month: 'short', timeZone: timezone }).format(dateTo),
            `${getFormatter(locale, { day: 'numeric', timeZone: timezone }).format(dateTo)},`,
            getFormatter(locale, { year: 'numeric', timeZone: timezone }).format(dateTo),
        ].join(' ');
    }

    if (viewType === 'month') {
        return getFormatter(locale, {
            month: 'long',
            year: 'numeric',
            timeZone: timezone,
        }).format(dateInTz.toJSDate());
    }

    return '';
};
